import scrollTo from './scrollTo';

const scrollToFirstError = () => {
  const element = document.getElementsByClassName('is-invalid')[0];
  if (element) {
    const offset = element.getBoundingClientRect();
    scrollTo(offset.top + window.scrollY - 100);
  }
};

export default scrollToFirstError;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/utils/scrollToFirstError.js